import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Typography, 
  Box, 
  Grid, 
  Container, 
  Card, 
  CardActionArea, 
  CardContent, 
  Paper,
  Divider,
  useTheme
} from '@mui/material';
import * as Icons from '@mui/icons-material';
import { db } from './Dexie';

function Home() {
  const navigate = useNavigate();
  const theme = useTheme();

  const logout = () => {
    db.delete({disableAutoOpen: false});
    navigate("/login");
  };

  const buttonData = [

    { 
      icon: <Icons.Telegram sx={{ fontSize: 48 }} />, 
      label: 'Telegram HUB', 
      description: 'Gestisci le funzionalità del bot di Telegram',
      color: theme.palette.primary.main, 
      onClick: () => navigate('/telegram') 
    },
    {
      icon: <Icons.Build sx={{ fontSize: 48 }} />,
      label: 'Utility',
      description: 'Strumenti e utilità varie',
      color: theme.palette.primary.main,
      onClick: () => {}
    },
    {
      icon: <Icons.PhoneCallback sx={{ fontSize: 48 }} />,
      label: '_docalls',
      description: 'Gestione delle chiamate _docalls',
      color: theme.palette.primary.main,
      onClick: () => navigate('/docalls')
    },
    { 
      icon: <Icons.MeetingRoom sx={{ fontSize: 48 }} />, 
      label: 'TechyShop', 
      description: 'Accedi al pannello di gestione TechyShop',
      color: theme.palette.primary.main, 
      onClick: () => navigate('/techyshop') 
    },
    { 
      icon: <Icons.Settings sx={{ fontSize: 48 }} />, 
      label: 'Impostazioni', 
      description: 'Configurazioni generali dell\'applicazione',
      color: theme.palette.primary.main, 
      onClick: () => navigate('/settings') 
    },
    { 
      icon: <Icons.Logout sx={{ fontSize: 48 }} />, 
      label: 'Logout', 
      description: 'Esci in sicurezza dal backoffice',
      color: theme.palette.error.main, 
      onClick: () => logout() 
    },
  ];

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      py: 6 
    }}>
      <Container maxWidth="lg">
        <Paper elevation={0} sx={{ 
          p: 4, 
          mb: 6, 
          background: 'transparent', 
          textAlign: 'center',
          color: 'white'
        }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 700, letterSpacing: '-0.5px' }}>
            Backoffice <Box component="span" sx={{ color: 'primary.main' }}>Atom</Box>
          </Typography>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', width: '100px', mx: 'auto', mt: 3 }} />
        </Paper>

        <Grid container spacing={3} justifyContent="center">
          {buttonData.map((item, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Card sx={{ 
                height: '100%', 
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',
                  boxShadow: `0 12px 24px rgba(0,0,0,0.4), 0 0 20px ${item.color} 22`,
                  borderColor: item.color,
                }
              }}>
                <CardActionArea onClick={item.onClick} sx={{ height: '100%', p: 2 }}>
                  <CardContent sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    textAlign: 'center' 
                  }}>
                    <Box sx={{ 
                      mb: 2, 
                      color: item.color,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      p: 2,
                      borderRadius: '50%',
                      backgroundColor: `${item.color}11`
                    }}>
                      {item.icon}
                    </Box>
                    <Typography variant="h5" component="h2" sx={{ mb: 1, fontWeight: 600, color: 'white' }}>
                      {item.label}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                      {item.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.3)' }}>
            Atom Backoffice © 2026 • Versione 1.0.0
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Home;
